import { HttpService } from '../../shared'
import qs from 'qs'

export default abstract class AbstractLinkedFilesProvider {
  protected urlPath: string

  constructor(protected http: HttpService, protected baseUrl: string) {}

  protected get url(): string {
    return `${this.baseUrl}/${this.urlPath}.php`
  }

  protected get query() {
    return qs
  }
}
